export const res = {
  loadingPKISIMTitle: {
    is: 'Fylgstu með símanum',
    en: 'Check your phone',
    pl: 'Sprawdź w swoim telefonie',
  } as const,
  loadingPKISIMDescription: (code: string) => {
    return {
      is: `Staðfestu aðeins ef auðkennisnúmerið ${code} birtist í símanum`,
      en: `Only confirm if the authentication number ${code} appears on the phone`,
      pl: `Potwierdź tylko w przypadku numeru identyfikacyjnego ${code}`,
    };
  },
};
